const G = window.g

export const cmsConfig = G ? G.cmsConf : '';